import { api } from "./api";
import { getPending, markSynced, setMeta, getMeta } from "./idb";

let _inflight = null;

async function _doSync() {
  if (!navigator.onLine) return { ok: false, reason: "offline" };
  let pushed = 0;
  let failed = 0;
  const pending = await getPending();
  for (const entry of pending) {
    try {
      const res = await api.post("/field-entries", {
        mission_id: entry.mission_id,
        project_id: entry.project_id,
        type: entry.type,
        title: entry.title,
        description: entry.description,
        photo_b64: entry.photo_b64,
        gps: entry.gps,
        measurements: entry.measurements,
        captured_at: entry.captured_at,
        local_id: entry.local_id,
      });
      await markSynced(entry.local_id, res.data.id);
      pushed++;
    } catch {
      failed++;
    }
  }
  await setMeta("last_sync_at", new Date().toISOString());
  // Broadcast so any UI listening can refresh
  try {
    window.dispatchEvent(new CustomEvent("btp:field-synced", { detail: { pushed, failed } }));
  } catch { /* ignore */ }
  return { ok: true, pushed, failed };
}

export async function syncPending() {
  // Coalesce concurrent callers — return same Promise
  if (_inflight) return _inflight;
  _inflight = _doSync().finally(() => { _inflight = null; });
  return _inflight;
}

export async function lastSync() {
  return await getMeta("last_sync_at");
}
